import type { ComponentTypesV2 } from 'types/selectComponent'
import BasicFilter from '../basic/BasicFilter'
import { CURRENT_FILTER_KEY_V2 } from '../currentType/CurrentTypeFilterNodeFactoryV2'
import type {
  ConfigurableFilterOptionsType,
  FilterComponentNodeV2,
  FilterGenericPropsType,
  FilterValuesType,
} from '../typeV2'
import { parseStringifiedListFilterValue } from '../utils/utils'
import {
  AC_VOLTAGE_RATING_BUCKET_FILTER_KEY_V2,
  AC_VOLTAGE_MINIMUM_OPTIONS,
} from './constants'

export const isACVoltageRatingFilterAvailableV2 = (filterValues: FilterValuesType) => {
  const currentTypes = parseStringifiedListFilterValue<ComponentTypesV2>({
    filterValues,
    key: 'types',
  })
  return currentTypes.has('isolator') && filterValues[CURRENT_FILTER_KEY_V2] === 'ac'
}

const createACVoltageRatingFilterNode = <T,>({
  label = 'Voltage Rating',
  ...restConfigs
}: ConfigurableFilterOptionsType<string, T>): FilterComponentNodeV2 => {
  const FilterComponent = (filterProps: FilterGenericPropsType) => {
    const isAvailable = isACVoltageRatingFilterAvailableV2(filterProps.allFilterValues)
    if (!isAvailable) return null

    const currentValue = filterProps.allFilterValues?.[AC_VOLTAGE_RATING_BUCKET_FILTER_KEY_V2]
    const defaultValue = currentValue ? String(currentValue) : 'all'

    return (
      <BasicFilter
        label={label}
        defaultSelectedOptionValue={defaultValue}
        options={AC_VOLTAGE_MINIMUM_OPTIONS}
        filterKey={AC_VOLTAGE_RATING_BUCKET_FILTER_KEY_V2}
        {...restConfigs}
        {...filterProps}
      />
    )
  }

  return {
    key: AC_VOLTAGE_RATING_BUCKET_FILTER_KEY_V2,
    component: FilterComponent,
  }
}

export default createACVoltageRatingFilterNode
